import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';

import 'Components/App/PrivacyChecker.scss';

function PrivacyChecker({ created }) {
  const [showPrivacy, setShowPrivacy] = useState(true);
  if (!created || !showPrivacy) {
    return false;
  }

  const createdDate = new Date(created);
  const seenPrivacy = localStorage.getItem('seenPrivacy');
  if (seenPrivacy || createdDate > new Date('2023-02-01T00:00:00.000Z')) {
    return false;
  }

  const closePrivacy = () => {
    const today = new Date();
    localStorage.setItem('seenPrivacy', today.getTime());
    setShowPrivacy(false);
  };

  return (
    <React.Fragment>
      <div className="PrivacyChecker">
        <div className="PrivacyChecker__privacyContainer">
          <FormattedMessage
            id="privacy.message1"
            defaultMessage="Our Privacy Policy has been updated. To view the updated policy {link}. Fanatical is part of the Fandom family."
            values={{
              link: <a
                href={'https://www.fandom.com/privacy-policy'}
                target="_blank"
                rel="noopener noreferrer"
                onClick={closePrivacy}
              >
                <FormattedMessage
                  id="privacy.message2"
                  defaultMessage="click here"
                />
              </a>,
            }}
          />

          <button className="PrivacyChecker__closeBtn" onClick={closePrivacy}>
            <FontAwesomeIcon icon={faCircleXmark} className="cross-icon" />
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}

PrivacyChecker.propTypes = {
  created: PropTypes.string,
};

PrivacyChecker.defaultProps = {
  created: '',
};

const mapStateToProps = ({
  auth: { created },
}) => ({
  created,
});

export default connect(mapStateToProps)(PrivacyChecker);
